import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Textarea, FormHandler } from 'Components/Form';
import { Card, CardBody } from 'Components/Card';
import { Socket, User } from 'Services';
import Question from 'Services/Api/MainStage/Question';
import { translation } from 'Services/TranslationHelpers';
import QuestionsApi from 'Services/Api/Admin/MainStage/Question';
import ChatMessage from './ChatMessage';
import { getFallbackAvatarUrl } from 'Services/AuthHelpers';

class MainStageQuestionsStandAlone extends React.Component {
    containerRef = null;
    titleRef = null;
    formRef = null;
    success = translation('main_stage_frontend', 'thank_you_for_submission');
    state = { questions: [] };

    async componentDidMount() {
        await this.fetchQuestions();
        this.subscribeToBroadcasts();

        this.setSize();
    }

    componentDidUpdate = (prevProps) => {
        if (window.base.main_stage.layout === 'tabs' && prevProps.height !== this.props.height) {
            this.setSize();
        }
    };

    componentWillUnmount = () => {
        if (this.alertHider) {
            clearTimeout(this.alertHider);
        }
        Socket.echo.leave(`main_stage_question.${this.props.sessionId}`);
    }

    setSize = () => {
        if (this.props.readOnly) {
            this.containerRef.style.height = `${window.innerHeight - this.titleRef.clientHeight - 96 - 240}px`;
        } else {
            this.containerRef.style.height = `${this.props.height - this.formRef.clientHeight - this.titleRef.clientHeight - 48}px`;
        }
    };

    fetchQuestions = async () => {
        let params = {};
        if (!this.props.readOnly) {
            params = { user_id: User.id };
        }
        const questions = await Question.get({ session: this.props.sessionId }, params);
        if (!questions.success) return;
        this.setState({ questions: questions.data.data });
    }

    subscribeToBroadcasts = () => {
        Socket.getConnection()
            .private(`main_stage_question.${this.props.sessionId}`)
            .listen('MainStageQuestionApproved', (e) => {
                if (!this.props.readOnly && User.id !== e.question.user_id) return;
                if (this.state.questions.filter(q => q.id === e.question.id).length > 0) return;
                this.setState({ questions: [e.question, ...this.state.questions] });
            })
            .listen('MainStageQuestionDeleted', (e) => {
                this.setState({ questions: this.state.questions.filter(q => q.id !== e.question.id) });
            });
    }

    handleSubmit = (form) => {
        return Question.post({ session: this.props.sessionId }, form).then((response) => {
            this.alertHider = setTimeout(() => {
                this.props.resetAlert();
            }, 5000);
            return response;
        });
    };

    deleteQuestion = async (id, key) => {
        const { questions } = this.state;
        await QuestionsApi.delete({ session: this.state.sessionId, lastResource: id });
        questions.splice(key, 1);
        this.setState({ questions });
    }

    getAvatarUrl = (user) => {
        return user.avatar_path && user.avatar_path.url ? user.avatar_path.url : getFallbackAvatarUrl(user);
    };

    render() {
        const { questions } = this.state;
        const { readOnly = false, heightRestriction = true, title = true, bgColour = 'bg-app-gray' } = this.props;

        return (
            <Card className={`h-full ${bgColour} text-app-blue rounded-xl rounder-b-none w-full mx-auto`} bgColour="bg-app-blue" titleColor="text-white">
                <CardBody className="h-full flex flex-grow flex-col">
                    {title && (
                        <div className="flex justify-between items-center mb-4">
                            <h1
                                className="text-2xl font-semibold text-center text-app-blue"
                                ref={ ref => this.titleRef = ref }
                            >
                                Questions
                            </h1>
                            <div className="flex space-x-2">
                                <div className="flex flex-col items-center text-xs">
                                    <div className="w-4 h-4 bg-app-light-blue"></div>
                                    <span>Virtual</span>
                                </div>
                                <div className="flex flex-col items-center text-xs">
                                    <div className="w-4 h-4 bg-app-blue"></div>
                                    <span>In Person</span>
                                </div>
                            </div>
                        </div>
                    ) }
                    <div
                        className={ `${heightRestriction ? 'max-h-[70-svh] md:max-h-[40em]' : ''} space-y-4 overflow-y-scroll w-full max-w-2l mx-auto py-2 ${ window.base.main_stage.layout === 'tabs' ? '' : 'h-full' }` }
                        ref={ ref => this.containerRef = ref }
                    >
                        { questions.map ( ( q, k ) => {
                            const user_message_group = q.user.first_group_name ?? '';

                            let virtual_group = user_message_group.includes ( 'virtual' );

                            return <div
                                key={ q.id }
                                className={ `flex ${ k % 2 === 0 ? 'flex-row' : 'flex-row w-full' } items-center` }
                            >
                                {/*{ window.base.features.avatar && (*/}
                                {/*    <img*/}
                                {/*        className={ `rounded-full h-8 w-8 ${ k % 2 === 0 ? 'mr-2' : 'ml-2' }` }*/}
                                {/*        src={ this.getAvatarUrl ( q.user ) }*/}
                                {/*        alt={ q.user?.full_name }*/}
                                {/*    />*/}
                                {/*) }*/}
                                <div className={` ${ virtual_group ? 'bg-app-light-blue' : 'bg-app-blue' } flex flex-col text-white rounded-xl p-3 w-full `}>
                                    <div className="flex justify-between text-xs mt-2">
                                        <span>{ q.user.first_name } { q.user.last_name }</span>
                                    </div>
                                    <div className="text-md mb-1 leading-5">
                                        { q.question.split ( '\n' ).map ( ( item, key ) => (
                                            <p
                                                className="mb-1"
                                                key={ key }
                                            >
                                                { item }
                                            </p>
                                        ) ) }
                                    </div>
                                    { User.data.is_admin && !readOnly && (
                                        <div className="ml-auto flex items-center text-xs">
                                            <button onClick={ () => this.deleteQuestion ( q.id, k ) }>
                                                <FontAwesomeIcon icon={ faTrash } />
                                            </button>
                                        </div>
                                    ) }
                                </div>
                            </div>
                        })}
                    </div>
                    {/*{!this.props.readOnly && this.renderForm()}*/}
                </CardBody>
            </Card>
        );
    }

    // renderForm = () => {
    //     const { form, alert, working, handleSubmit, handleInput } = this.props;
    //     let placeholder = translation('main_stage_frontend', 'type_question');
    //
    //     return (
    //         <form ref={ref => this.formRef = ref} className="relative flex flex-col justify-between" onSubmit={(e) => handleSubmit(e, this.handleSubmit, this.success, true)}>
    //             {alert && (
    //                 <div className="w-full rounded-xl absolute z-10 -translate-y-full">
    //                     <Alert containerStyles="p-4" {...alert} />
    //                 </div>
    //             )}
    //             <div className="relative">
    //                 <Textarea placeholder={placeholder} rows={5} onChange={(v) => handleInput('question', v)} value={form.question ?? ''} />
    //                 <FontAwesomeIcon icon={faPaperPlane} size="1x" onClick={() => !working && form.question ? handleSubmit(null, this.handleSubmit, this.success, true) : false} className="absolute top-8 right-6 text-black cursor-pointer" />
    //             </div>
    //         </form>
    //     );
    // }
}

export default FormHandler(MainStageQuestionsStandAlone);
